<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";
import { mapState } from "vuex";

export default {
  name: "NetworkIndication",

  components: {
    Layout,
    VclList,
  },

  data() {
    return {
      loading: true,
      errored: false,

      items: [],
      totalUsers: 0,

      currentPage: 1,
      perPage: 25,
      sortBy: "name",
      sortDesc: false,

      NameFilter: "",

      fields: [
        { key: "avatar", label: "" },
        { key: "plan", label: "Tipo", sortable: true },
        { key: "name", label: "Nome", sortable: true },
        { key: "sponsor", label: "Responsável", sortable: true },
        { key: "date", label: "Data", sortable: true },
        { key: "documentation", label: "Documentação" },
        { key: "status", label: "Status" },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  computed: {
    ...mapState({ account: (state) => state.account }),

    isRegional() {
      return this.account?.user?.package === "Regional";
    },
  },

  methods: {
    getList() {
      this.loading = true;
      this.errored = false;

      api
        .get(
          "network/indications?searchname=" +
            encodeURIComponent(this.NameFilter)
        )
        .then((response) => {
          if (response.data.status === "success") {
            this.items = response.data.list;
            this.totalUsers = response.data.list.length;
          } else {
            this.items = [];
            this.totalUsers = 0;
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    viewIndication(id) {
      this.$router.push(`/network/indicados/${id}`);
    },

    approveIndication(id) {
      this.$bvModal
        .msgBoxConfirm("Deseja realmente aprovar este cadastro?", {
          title: "Confirmar Aprovação",
          okVariant: "success",
          okTitle: "Aprovar",
          cancelTitle: "Cancelar",
          centered: true,
        })
        .then((confirmed) => {
          if (!confirmed) return;

          api.post("network/approveIndication", { id }).then(() => {
            this.$toast.success("Cadastro aprovado com sucesso.");
            this.getList();
          });
        });
    },

    reproveIndication(id) {
      this.$bvModal
        .msgBoxConfirm("Deseja realmente reprovar este cadastro?", {
          title: "Confirmar Reprovação",
          okVariant: "danger",
          okTitle: "Reprovar",
          cancelTitle: "Cancelar",
          centered: true,
        })
        .then((confirmed) => {
          if (!confirmed) return;

          api.post("network/reproveIndication", { id }).then(() => {
            this.$toast.success("Cadastro reprovado.");
            this.getList();
          });
        });
    },
  },

  mounted() {
    this.getList();
  },

  watch: {
    NameFilter() {
      this.getList();
    },
  },
};
</script>

<template>
  <Layout>
    <div class="container-fluid">

      <!-- TÍTULO -->
      <div class="page-title-box d-md-flex justify-content-between mb-3">
        <div>
          <h3>Indicações</h3>
        </div>
      </div>

      <!-- FILTRO -->
      <div class="d-flex mb-4">
        <div class="totals mr-3">
          <h6 class="m-0 text-secondary">Filtrar por nome</h6>
        </div>
        <input
          v-model="NameFilter"
          type="text"
          class="form-control search"
          aria-label="Nome do indicado"
          placeholder="Nome do indicado"
        />
      </div>

      <!-- TABELA -->
      <div class="card">
        <div class="card-body min-vh-25">

          <div v-if="errored" class="text-center min-vh-25">
            Não foi possível carregar as informações.
          </div>

          <vcl-list v-else-if="loading" class="col-md-6" />

          <div
            v-else-if="items.length === 0"
            class="text-center min-vh-25 d-flex align-items-center justify-content-center"
          >
            <strong>Nenhuma indicação encontrada.</strong>
          </div>

          <div v-else class="table-responsive">
            <b-table stacked="md"
              :items="items"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :current-page="currentPage"
              :per-page="perPage"
              class="table-nowrap table-hover"
              head-variant="light"
            >
              <template #cell(avatar)="row">
                <img
                  :src="row.item.avatar ||
                    'https://ui-avatars.com/api/?background=27416E&color=fff&name=' + row.item.name"
                  class="rounded-circle"
                  style="width:40px;height:40px"
                />
              </template>

              <template #cell(documentation)="row">
                <strong>
                  {{ row.item.documentation.required }}/{{ row.item.documentation.sent }}
                </strong>
              </template>

              <template #cell(status)="row">
                <span
                  v-if="row.item.status === 'waiting_docs'"
                  class="badge badge-soft-warning"
                >
                  Aguardando Documentação
                </span>

                <span
                  v-else-if="row.item.status === 'reproved'"
                  class="badge badge-soft-danger"
                >
                  Reprovado
                </span>

                <span
                  v-else
                  class="badge badge-soft-info"
                >
                  Aguardando Cadastro
                </span>
              </template>

              <template #cell(actions)="row">
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="viewIndication(row.item.id)"
                >
                  Ver
                </b-button>

                <template v-if="row.item.status === 'waiting_approval' && isRegional">
                  <b-button
                    size="sm"
                    variant="success"
                    class="ml-2"
                    @click="approveIndication(row.item.id)"
                  >
                    Aprovar Indicado
                  </b-button>

                  <b-button
                    size="sm"
                    variant="danger"
                    class="ml-2"
                    @click="reproveIndication(row.item.id)"
                  >
                    Reprovar Indicado
                  </b-button>
                </template>
              </template>
            </b-table>

            <b-pagination
              v-if="totalUsers > perPage"
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              align="center"
              pills
              class="mt-3"
            />
          </div>

        </div>
      </div>

    </div>
  </Layout>
</template>
